export default __webpack_public_path__ + "static/media/cycle.897b9987.png";